var publicPath = __webpack_public_path__;
                    var symbolUrl = 'svg-sprite-4717975078b535c790596dd75dea4ddc.svg#icon-logedin-user-icon-71ed4';
                    var viewUrl = 'svg-sprite-4717975078b535c790596dd75dea4ddc.svg#view-icon-logedin-user-icon-71ed4';

                    

                    module.exports = {
                        symbol: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 24 24',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };